import axios from 'axios'

export default class AjaxLangSwitch {
	constructor() {
		this._ajaxContent = document.querySelector(".ajax-data-lang");
		this._langToogle= document.querySelector(".jsLangSwitchToggle");
		this._vawcCat = document.querySelectorAll(".vawc-cat");
		this.init();
	}

	ajax (url, type, postUrl, category) {
		this._ajaxContent.classList.add('splash');
		axios.post(url, {type: type, posturl: postUrl, cat: category}).then((response) => {
			this._ajaxContent.innerHTML = response.data;
			this._ajaxContent.classList.remove('splash');
		});
	}

	init() {
		if(this._langToogle){
			this._langToogle.addEventListener("change", (event) => {

				var currentURL = window.location.pathname.split('/');
				var category = null;

				if (currentURL[3] !== undefined && currentURL[3].indexOf('p') == -1 && currentURL[3] !== '') {
					var postUrl = '/' + currentURL[1] + '/' + currentURL[2] + '/' + currentURL[3] + '/' + currentURL[4];
					var category = currentURL[4];
				}
				else{
					var postUrl = '/' + currentURL[1] + '/' + currentURL[2];
				}

				if(this._langToogle.checked == true){
			        history.pushState(null, '', postUrl + '/?lang=' + 'es');
			        this.ajax(this._langToogle.dataset.src, 'es', postUrl, category);
			        this._langToogle.setAttribute('checked', '');
			        for (let k = 0; k < this._vawcCat.length; k++) {
			        	var caturl = this._vawcCat[k].href.split('?');
			        	this._vawcCat[k].setAttribute('href', caturl[0] + '?lang=es');
			        }
			    }
			    else if(this._langToogle.checked == false){
			    	history.pushState(null, '', postUrl + '/?lang=' + 'en');
			    	this.ajax(this._langToogle.dataset.src, 'en', postUrl, category);
			        this._langToogle.removeAttribute('checked', '');
			        for (let k = 0; k < this._vawcCat.length; k++) {
			        	var caturl = this._vawcCat[k].href.split('?');
			        	this._vawcCat[k].setAttribute('href', caturl[0] + '?lang=en');
			        }
			    }
			});
		}
	}
}